// Module
var code = "<react-component name=\"HiitAttendanceReport\"></react-component>\n";
// Exports
module.exports = code;